import type { ListMoviesRequest, ListTermsRequest } from '@zyx/shared';

/**
 * Query keys. Switching services clears the whole cache (see use-connection), so keys
 * need not name the service. Marks change what every movie list shows, so `movies` is
 * one prefix to invalidate.
 */
export const queryKeys = {
  ping: () => ['ping'] as const,
  movies: () => ['movies'] as const,
  movieList: (request: ListMoviesRequest) => ['movies', 'list', request] as const,
  movie: (code: string) => ['movies', 'detail', code] as const,
  continueWatching: () => ['movies', 'continue-watching'] as const,
  person: (personId: number) => ['people', personId] as const,
  term: (termId: number) => ['terms', termId] as const,
  terms: (request: ListTermsRequest) => ['terms', 'list', request] as const,
  /** Under `movies`: a list's count and cover change with every mark. */
  lists: () => ['movies', 'lists'] as const,
  list: (listId: number) => ['movies', 'lists', listId] as const,
  bookmarks: () => ['bookmarks'] as const,
  movieBookmarks: (code: string) => ['bookmarks', code] as const,
  downloads: () => ['downloads'] as const,
  movieDownloads: (code: string) => ['downloads', code] as const,
  /** Under `movies`: hiding a movie changes how many browsing shows. */
  stats: () => ['movies', 'stats'] as const,
};
